export default __webpack_public_path__ + "static/pic1-460ad7eb32c759e09c2e375819697bfb.jpg";